import { render, staticRenderFns } from "./pagamento.vue?vue&type=template&id=873c1e44"
import script from "./pagamento.ts?vue&type=script&lang=js&external"
export * from "./pagamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('873c1e44')) {
      api.createRecord('873c1e44', component.options)
    } else {
      api.reload('873c1e44', component.options)
    }
    module.hot.accept("./pagamento.vue?vue&type=template&id=873c1e44", function () {
      api.rerender('873c1e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/pagamento.vue"
export default component.exports